// Mobile carousel for the icon feature row: 2x2 pages in a scroll-snap track
// with dots. Same dot contract as the PDP cross-sell (pdp.js): click scrolls
// to page * track width, a debounced scroll listener syncs the active dot.
// Desktop renders the plain grid, so the track never overflows and the dots
// are hidden by CSS; the listeners are harmless there.

const initIconFeatureRowSection = (section) => {
  if (!section || section.dataset.iconFeatureRowInitialized === "true") return;

  const track = section.querySelector("[data-icon-feature-row-track]");
  const dots = Array.from(section.querySelectorAll("[data-icon-feature-row-dot]"));

  if (!track || !dots.length) return;

  section.dataset.iconFeatureRowInitialized = "true";

  let scrollEndTimer = null;

  const setActiveDot = (index) => {
    dots.forEach((dot, i) => {
      dot.classList.toggle("is-active", i === index);
    });
  };

  const currentPage = () => {
    const width = track.clientWidth;
    if (!width) return 0;
    return Math.min(dots.length - 1, Math.max(0, Math.round(track.scrollLeft / width)));
  };

  dots.forEach((dot) => {
    dot.addEventListener("click", () => {
      const index = parseInt(dot.getAttribute("data-icon-feature-row-dot"), 10);
      if (Number.isNaN(index)) return;

      track.scrollTo({ left: index * track.clientWidth, behavior: "smooth" });
      setActiveDot(index);
    });
  });

  track.addEventListener(
    "scroll",
    () => {
      window.clearTimeout(scrollEndTimer);
      scrollEndTimer = window.setTimeout(() => setActiveDot(currentPage()), 80);
    },
    { passive: true }
  );

  window.addEventListener("resize", () => setActiveDot(currentPage()));
};

const initIconFeatureRow = (root = document) => {
  if (!root) return;

  if (root.matches && root.matches("[data-icon-feature-row]")) {
    initIconFeatureRowSection(root);
  }

  if (root.querySelectorAll) {
    root.querySelectorAll("[data-icon-feature-row]").forEach(initIconFeatureRowSection);
  }
};

export { initIconFeatureRow };
